import { capabilityRequest } from "../services/capability-client.service";
import { PublicCatalogSchema, ServiceAvailabilitySchema, PublicReviewsResultSchema, } from "../models";
function query(params) {
    const entries = Object.entries(params).filter(([, value]) => value !== undefined);
    if (!entries.length)
        return "";
    return `?${new URLSearchParams(entries.map(([key, value]) => [key, String(value)])).toString()}`;
}
export const publicCatalogRepository = {
    async getCatalog(apiBaseUrl, orgId, rootGrant) {
        const data = await capabilityRequest({
            apiBaseUrl,
            accessGrant: rootGrant,
            path: `/api/v2/organizations/${orgId}/catalogs/public`,
        });
        return PublicCatalogSchema.parse(data);
    },
    async getAvailability(apiBaseUrl, orgId, serviceId, rootGrant, params) {
        const data = await capabilityRequest({
            apiBaseUrl,
            accessGrant: rootGrant,
            path: `/api/v2/organizations/${orgId}/catalogs/public/services/${serviceId}/availability${query({ ...params })}`,
        });
        return ServiceAvailabilitySchema.parse(data);
    },
    // The wire response for this route is documented as double-wrapped —
    // `{ data: { data: [...], meta: {...} } }` instead of the standard v2
    // envelope. `capabilityRequest` already strips the outer `data`, so what
    // arrives here is the inner `{ data, meta }` object. This is flagged as
    // provisional in the contract itself; confirm against a running server
    // before relying on it.
    async getReviews(apiBaseUrl, orgId, serviceId, rootGrant, params) {
        const data = await capabilityRequest({
            apiBaseUrl,
            accessGrant: rootGrant,
            path: `/api/v2/organizations/${orgId}/catalogs/public/services/${serviceId}/reviews${query({
                page: params?.page,
                limit: params?.limit,
            })}`,
        });
        return PublicReviewsResultSchema.parse({ reviews: data.data, meta: data.meta });
    },
};
export default publicCatalogRepository;
